import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=7a54ae01&scoped=true&"
import script from "./goodsAdd.vue?vue&type=script&lang=js&"
export * from "./goodsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a54ae01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a54ae01')) {
      api.createRecord('7a54ae01', component.options)
    } else {
      api.reload('7a54ae01', component.options)
    }
    module.hot.accept("./goodsAdd.vue?vue&type=template&id=7a54ae01&scoped=true&", function () {
      api.rerender('7a54ae01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nine/components/goodsAdd.vue"
export default component.exports